import { render, staticRenderFns } from "./SpecialPageCarousel.vue?vue&type=template&id=2af5f814&scoped=true&"
import script from "./SpecialPageCarousel.vue?vue&type=script&lang=js&"
export * from "./SpecialPageCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SpecialPageCarousel.vue?vue&type=style&index=0&id=2af5f814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af5f814",
  null
  
)

export default component.exports